import { render, staticRenderFns } from "./AddAdvocatApp.vue?vue&type=template&id=33d04a62&scoped=true&lang=pug&"
import script from "./AddAdvocatApp.vue?vue&type=script&lang=js&"
export * from "./AddAdvocatApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d04a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAutocomplete,VForm})
